export default function ($translate) {
    return {
        KEYS: {
            NOT_STARTED: 'NOT_STARTED',
            REGISTERED: 'REGISTERED',
            IN_PROGRESS: 'IN_PROGRESS',
            PASSED: 'PASSED',
            NOT_PASSED: 'NOT_PASSED',
            COMPLETED: 'COMPLETED',
            NOT_COMPLETED: 'NOT_COMPLETED'
        },
        LABELS: {
            NOT_STARTED: $translate.instant('course.statusType.NotStarted'),
            REGISTERED: $translate.instant('course.statusType.Registered'),
            IN_PROGRESS: $translate.instant('course.statusType.InProgress'),
            PASSED: $translate.instant('course.statusType.Passed'),
            NOT_PASSED: $translate.instant('course.statusType.NotPassed'),
            COMPLETED: $translate.instant('course.statusType.Completed'),
            NOT_COMPLETED: $translate.instant('course.statusType.NotCompleted')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/statusType/index.js